import { render, staticRenderFns } from "./RPSCaseField.vue?vue&type=template&id=14bdbc00&scoped=true"
import script from "./RPSCaseField.vue?vue&type=script&lang=js"
export * from "./RPSCaseField.vue?vue&type=script&lang=js"
import style0 from "./RPSCaseField.vue?vue&type=style&index=0&id=14bdbc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bdbc00",
  null
  
)

/* custom blocks */
import block0 from "./RPSCaseField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports